import React, { useEffect } from "react";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";


import AOS from "aos";
import "aos/dist/aos.css";
import Metatag from "../../components/Metatag/Metatag";

const Joinus = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  useEffect(()=>{
    AOS.init({
      once:true,
    })
  },[])

  const req = require.context("../../assets/images/compressed/", false, /\.(png|jpe?g|svg|webp)$/);
  const images = req.keys().map((key, index) => ({
    src: req(key),
    alt: `img${index + 1}`
  }));

  return (
    <div>
      <Metatag title="Join Us - Be a Part of Our Community | Megavolt Technical Services" description="Explore exciting opportunities and become a valued member Megavolt Technical Services. Join us to grow,connect, and make an impact. Learn more about our mission and how you can get involved today!" link="joinus"/>
      <h1 className="font-bold text-3xl text-center my-8">Our Projects</h1>

      <div className="mx-auto p-3 lg:container md:py-6">
        <div>
          <SlideshowLightbox
            lightboxIdentifier="lightbox1"
            framework="next"
            images={images}
          >
            <div className="grid md:grid-cols-3 grid-cols-1 gap-2 md:gap-4">
              {images.map((image, index) => (
                <div
                  key={index}
                  className="relative overflow-hidden rounded group"
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  data-aos-offset='50'
                  data-aos-delay={index * 100}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    data-lightboxjs="lightbox1"
                    className="w-full h-full object-cover aspect-[4/3] transition duration-300 ease-in-out group-hover:scale-110"
                    loading="eager"
                    priority
                  />
                  <div className="absolute inset-0 bg-[#00000034] group-hover:hidden"></div>
                </div>
              ))}
            </div>
          </SlideshowLightbox>
        </div>
      </div>
    </div>
  );
};

export default Joinus;
